import { createSelector } from 'reselect';
import { RouteName } from '@mews-commander/enums';
import { getProp, getStringProp } from '@mews/fp';
import { ResolveRoute } from '@mews/routing';

export const getRestrictionCreateUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('serviceId'),
    (resolveRoute, serviceId) => resolveRoute(RouteName.RestrictionCreate, { query: { OwnerId: serviceId } })
);
